import * as gfunctions from '../../../js/generalFunctions';

CCL.termsAndConditions = {
  autoload: [
    ['initialLoad', $('#termsAndConditionsModal').length > 0]
  ],

  initialLoad() {
    $('body').on('click', '.terms-conditions-btn', (e) => {
      this.loadJsonData(e);
    });
  },

  closeModal() {
    $('.close').click((e) => {
      gfunctions.hideModal('transfersConflictModal');
      gfunctions.hideModal('alcoholAtcModal');
    });
  },

  checkboxEvent() {
    $('.read-check input[type="checkbox"]').click((e) => {
      if ($('.read-check input[type="checkbox"]').length === $('.read-check input[type="checkbox"]:checked').length) {
        $('.btn-tc-add-cart').removeClass('btn-disable');
      } else {
        $('.btn-tc-add-cart').addClass('btn-disable');
      }
    });
  },
  quantitySet(productCodePost, event, currentElement) {
    const bookings = [];
    const dataObj = {};
    sessionStorage.clear();
    const booking = currentElement.parents('.c-cart-card,.c-pdp-card,.alcohol-atc-modal-dialog').find('.custom-control.custom-checkbox.stateroom-check > input[type="checkbox"]:checked');
    booking.each((index, element) => {
      let quantity = '';
      if (currentElement[0].dataset.ispdp === ('true' || true)) {
        quantity = currentElement.parents('.c-pdp-card').find('.quantity-input-1').val();
      } else {
        quantity = currentElement.parents('.alcohol-atc-modal-dialog,.c-cart-card').find('.quantity-input-1').val();
      }
      const bookingIdValue = element.dataset.bookingid;
      const addedQty = element.dataset.qty;
      const guestArray = [];
      if (element.parentElement.classList.contains('stateroom-disabled')) {
        quantity = 0;
      }
      if (Number(quantity) === 2 && Number(addedQty) === 1) {
        quantity = 1;
      }
      const abc = $(element);
      if (!abc.is(':checked')) {
        quantity = 0;
      }
      let ac = '';
      if (currentElement[0].dataset.ispdp === ('true' || true)) {
        ac = $(element.parentElement.children[3]);
      } else {
        ac = $(element.parentElement);
      }
      ac.find('.guests-check > input[type="checkbox"]:checked').each((i, elem) => {
        if (!$(elem).prop('disabled')) {
          const guestValue = elem.dataset.guestid;
          const guestObj = {
            guestId: guestValue
          };
          guestArray.push(guestObj);
        }
      });
      let q = 0;
      if ($('.terms-conditions-btn').data('producttype') === 'SF' || $('.c-cart-card .time-conflict-panel-heading').data('producttype') === 'SF') {
        q = Number(quantity);
      } else {
        q = 1;
        sessionStorage.setItem('producttype', 'SFAP');
      }
      const qtyAdded = element.dataset.qtyadded;
      const purchaseQty = element.dataset.purchaseqty;
      const qty = $(element).closest('.c-cart-card').find('.quantity-input-1').val();
      if (qtyAdded !== (null || undefined) && purchaseQty !== (null || undefined)) {
        if (qty !== (null || undefined) && qtyAdded === purchaseQty) {
          q = qty;
        } else if (purchaseQty - qtyAdded === 1) {
          q = 1;
        }
      }

      // currentElement.each((ind, elemnt) => {
      //   /* eslint-disable */
      //   if (isNaN(q) && elemnt.dataset.upsellqty) {
      //     q = elemnt.dataset.upsellqty;
      //   }
      //   /* eslint-enable */
      // });
      const bookingData = {
        qty: q,
        bookingId: bookingIdValue,
        guestIds: guestArray
      };
      bookings.push(bookingData);
    });
    dataObj.bookings = bookings;
    dataObj.productCodePost = productCodePost;
    sessionStorage.setItem('sessionTemplateObj', JSON.stringify(dataObj));
  },

  loadJsonData(event) {
    const hasupsell = $(event.target).attr('data-hasupsell');
    if (hasupsell === 'true' &&
      typeof hasupsell !== typeof undefined &&
      hasupsell !== false) {
      gfunctions.showLoader();
      let ajaxUrlTmp = '';
      if (window.location.hostname === 'localhost' && window.location.port === '6565') {
        ajaxUrlTmp = 'json-data/upsell-product.json';
      } else {
        ajaxUrlTmp = '/shop/cart/productreference';
      }

      let quantityTmp = 1;

      if ($(event.target).parents('.c-pdp-card, .modal-content').find('.quantity-input').length) {
        quantityTmp = $(event.target).parents('.c-pdp-card, .modal-content').find('.quantity-input').val();
      } else if ($(event.target).parents('.c-pdp-card, .modal-content').find('.quantity-input-1').length) {
        quantityTmp = $(event.target).parents('.c-pdp-card, .modal-content').find('.quantity-input-1').val();
      }

      const bookingIdsArray = $(event.target).attr('data-bookingIds') ? $(event.target).attr('data-bookingIds').split(',') : [];
      const guestIdsArray = $(event.target).attr('data-guestIds') ? $(event.target).attr('data-guestIds').split(',') : [];
      const { ispdp } = event.target.dataset;
      const dataObjTmp = {
        productCode: $(event.target).data('productcode'),
        referenceType: 'UPSELLING',
        qty: quantityTmp || 1,
        encBookingIds: bookingIdsArray,
        encGuestIds: guestIdsArray,
        pdpPage: (ispdp === 'true' && typeof ispdp !== typeof undefined && ispdp !== false)
      };

      $.ajax({
        type: 'POST',
        url: ajaxUrlTmp,
        data: JSON.stringify(dataObjTmp),
        headers: {
          CSRFToken: $('#csrfSessionToken').data('csrf')
        },
        contentType: 'application/json'
      }).done((response) => {
        gfunctions.hideLoader();
        if (response.productValid) {
          CCL.upSellProductModal.openGlobalUpsellModal(response);
        } else {
          this.loadTnC(event);
        }
      })
        .fail(() => {
          gfunctions.hideLoader();
          console.log('error Occured');
          this.loadTnC(event);
        });
    } else {
      this.loadTnC(event);
    }
  },

  loadTnC(event) {
    const csrf = $(event.target).data('csrf') ? $(event.target).data('csrf') : $('#csrfSessionToken').data('csrf');
    const targetElement = $(event.target).data('hasvariants');
    const quantity = $(event.target).parents('.c-pdp-card, .modal-content').find('.quantity-input') && $(event.target).parents('.c-pdp-card, .modal-content').find('.quantity-input').val();
    const variantId = $(event.target).attr('data-variantids');
    const isSpecialService = $(event.target).attr('data-specialService');
    const bookingIdsArray = $(event.target).attr('data-bookingIds') ? $(event.target).attr('data-bookingIds').split(',') : '';
    const guestIdsArray = $(event.target).attr('data-guestIds') ? $(event.target).attr('data-guestIds').split(',') : '';
    const productCode = $(event.target).data('productcode');
    const dataObj = {
      productCodePost: $(event.target).data('productcode'),
      CSRFToken: csrf,
      qty: quantity || 1,
      variantIds: variantId,
      bookingIds: bookingIdsArray,
      guestIds: guestIdsArray,
      specialService: isSpecialService
    };
    if ($('.terms-conditions-btn').data('producttype') === 'SF' || $('.terms-conditions-btn').data('producttype') === 'SFAP') {
      const currentElement = $('.terms-conditions-btn');
      this.quantitySet(productCode, event, currentElement);
    }
    let ajaxUrl = '';
    let ajaxType = '';
    if (window.location.hostname === 'localhost' && window.location.port === '6565') {
      ajaxUrl = '/_ui/responsive/ccl/assets/templates/terms-conditions-modal/terms-conditions.json';
      ajaxType = 'GET';
    } else {
      ajaxUrl = '/shop/termsconditions';
      ajaxType = 'POST';
    }
    $.ajax({
      type: ajaxType,
      url: ajaxUrl,
      contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
      data: dataObj,
      headers: {
        CSRFToken: csrf
      }
    }).done((res) => {
      gfunctions.hideModal('clpAddToCartModal');
      gfunctions.hideModal('alcoholAtcModal');
      gfunctions.hideModal('globalUpsellProductModal');
      // $('.modal').modal('hide');
      this.loadHtmlData(res);
    }).fail(() => {
      gfunctions.hideLoader();
      console.log('error while fetching data');
    });
  },


  loadHtmlData(jsonData) {
    $.ajax({
      type: 'GET',
      url: '/_ui/responsive/ccl/assets/templates/terms-conditions-modal/terms-conditions.html'
    }).done((response) => {
      // append the booking ids and the guest ids to the Add to Cart btn
      const html = gfunctions.createDynamicHTML(response, jsonData);
      $('#termsAndConditionsModal').empty().append(html);
      $('.pdp-add-to-cart-btn').attr('data-bookingIds', jsonData.bookingIds);
      $('.pdp-add-to-cart-btn').attr('data-guestIds', jsonData.guestIds);
      $('.pdp-add-to-cart-btn').attr('data-productcode', jsonData.code);
      if (jsonData.productType.toLowerCase() === 'cheers' || jsonData.productType.toLowerCase() === 'bubble') {
        $('.read-check >input').attr('checked', 'checked');
        $('.btn-tc-add-cart').removeClass('btn-disable');
      }
      this.checkboxEvent();
      this.closeModal();
      gfunctions.showModal('termsAndConditionsModal');
      this.modalEvents();

      setTimeout(() => {
        $('body').addClass('modal-open');
      }, 600);
    }).fail(() => {
      gfunctions.hideLoader();
      console.log('error while loading html');
    });
  },

  modalEvents() {
    const modalEl = $('#termsAndConditionsModal');

    modalEl.find('button.close').on('keydown', (event) => {
      if ((event.keyCode === 9) && (event.shiftKey)) {
        event.preventDefault();
        const lastFocusable = gfunctions.getFocusableElements(modalEl, 'last');
        lastFocusable.focus();
        if ((modalEl.find('.general-add-to-cart-btn:disabled').length > 0) || (modalEl.find('.general-add-to-cart-btn.btn-disable').length > 0)) {
          modalEl.find('.btn-cancel').focus();
        } else {
          modalEl.find('.general-add-to-cart-btn').focus();
        }
      }
    });
    modalEl.find('.btn-cancel').on('keydown', (event) => {
      if ((event.keyCode === 9) && !(event.shiftKey)) {
        event.preventDefault();
        if ((modalEl.find('.general-add-to-cart-btn:disabled').length > 0) || (modalEl.find('.general-add-to-cart-btn.btn-disable').length > 0)) {
          const firstFocusable = gfunctions.getFocusableElements(modalEl);
          firstFocusable.focus();
        } else {
          modalEl.find('.general-add-to-cart-btn').focus();
        }
      }
    });
    modalEl.find('.general-add-to-cart-btn').on('keydown', (event) => {
      if ((event.keyCode === 9) && !(event.shiftKey)) {
        event.preventDefault();
        const firstFocusable = gfunctions.getFocusableElements(modalEl);
        firstFocusable.focus();
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/components/c-tc-modal/c-tc-modal.js